import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from "@angular/router";
import { Logger } from "src/app/services/logger/logger.service";

const logger = new Logger('MasterDetailRouteReuseStrategy');
export class MasterDetailRouteReuseStrategy implements RouteReuseStrategy {

    detachedRoute:any;

    reuseRoutes = new Map();

    private routeStore = new Map();

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        if(route.data['routeData']){
            this.detachedRoute = route.data['routeData'] + route.params['id'];
        } else{
            this.detachedRoute = route.routeConfig?.path;
        }
        if(route.data && route.data['reuseRoute']){
            this.reuseRoutes.set(this.detachedRoute,true);
            return true;
        }
        return false;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
        this.routeStore.set(route.routeConfig?.path,handle);
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        let path: any;
        if(route.data['routeData']){
             path = route.data['routeData'] + route.params['id'];
        } else{
             path = route.routeConfig?.path;
        }


        const backBtnStatus = localStorage.getItem('backBtnclicked') ? localStorage.getItem('backBtnclicked')?.split('_'): [];
        if(backBtnStatus&&  backBtnStatus[0] == 'true'  && this.reuseRoutes.has(path)){
            return true;
        }
        return false;
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        const path = route.routeConfig?.path;
        if(this.routeStore.has(path)){
           return this.routeStore.get(path);
        }
        return null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

}
